export function isEmpty(value) {
  return value.trim() === "";
}

export function isContatNo(value) {
  return value.length < 7 || value.length > 20;
}

export function isEmail(value) {
  return String(value)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}

export function isNotPostiveNumber(value) {
  const exceptThisSymbols = ["e", "E", "+", "-", "."];
  return exceptThisSymbols.includes(value);
}

export function stateInfo(storeDetails) {
  return [
    { zone_id: "1", name: "Andhra Pradesh" },
    { zone_id: "2", name: "Arunachal Pradesh" },
    { zone_id: "3", name: "Assam" },
    { zone_id: "4", name: "Bihar" },
    { zone_id: "5", name: "Chhattisgarh" },
    { zone_id: "6", name: "Goa" },
    { zone_id: "7", name: "Gujarat" },
    { zone_id: "8", name: "Haryana" },
    { zone_id: "9", name: "Himachal Pradesh" },
    { zone_id: "10", name: "Jharkhand" },
    { zone_id: "11", name: "Karnataka" },
    { zone_id: "12", name: "Kerala" },
    { zone_id: "13", name: "Madhya Pradesh" },
    { zone_id: "14", name: "Maharashtra" },
    { zone_id: "15", name: "Manipur" },
    { zone_id: "16", name: "Meghalaya" },
    { zone_id: "17", name: "Mizoram" },
    { zone_id: "18", name: "Nagaland" },
    { zone_id: "19", name: "Odisha" },
    { zone_id: "20", name: "Punjab" },
    { zone_id: "21", name: "Rajasthan" },
    { zone_id: "22", name: "Sikkim" },
    { zone_id: "23", name: "Tamil Nadu" },
    { zone_id: "24", name: "Telangana" },
    { zone_id: "25", name: "Tripura" },
    { zone_id: "26", name: "Uttar Pradesh" },
    { zone_id: "27", name: "Uttarakhand" },
    { zone_id: "28", name: "West Bengal" }
  ];
}

export function decodeHTMLEntities(text) {
  var entities = [
    ['amp', '&'],
    ['apos', '\''],
    ['#x27', '\''],
    ['#x2F', '/'],
    ['#39', '\''],
    ['#47', '/'],
    ['lt', '<'],
    ['gt', '>'],
    ['nbsp', ' '],
    ['quot', '"']
  ];

  for (var i = 0, max = entities.length; i < max; ++i)
    text = text.replace(new RegExp('&' + entities[i][0] + ';', 'g'), entities[i][1]);

  return text;
}